<nz-checkbox-wrapper (nzOnChange)="setLayers($event)">
    <label  *ngFor="let layer of enabledLayers"
            nz-checkbox 
            [nzValue]="layer.id">{{ layer.name }}</label>
</nz-checkbox-wrapper>

